export const SERVICE_TYPES = "/api/pa/Reference/ServiceTypes"
export const SERVICE_TYPE = "/api/pa/Reference/ServiceType/:param"
